import {
  ActionIcon,
  Button,
  Flex,
  Group,
  Menu,
  Table,
  Text,
  ThemeIcon,
} from '@mantine/core'
import classes from './AdminSettings.module.css'
import { IconDots, IconGripVertical } from '@tabler/icons-react'
import { Outlet, useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'

const MOCK_DATA = [
  {
    name: 'No answer',
    type: 'Not answered',
  },
  {
    name: 'Voicemail',
    type: 'Answered',
  },
  {
    name: 'Requested callback',
    type: 'Answered',
  },
  {
    name: 'Busy / Call back',
    type: 'Answered',
  },
  {
    name: 'Answered (Positive)',
    type: 'Answered',
  },
  {
    name: 'Answered (Negative)',
    type: 'Answered',
  },
  {
    name: 'Wrong number',
    type: 'Answered',
  },
]

export const CallsDispositions = () => {
  const navigate = useNavigate()

  const rows = MOCK_DATA.map((item) => (
    <Table.Tr key={item.name}>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Group gap={5}>
          <ThemeIcon variant="transparent" color="gray.7">
            <IconGripVertical size={22} />
          </ThemeIcon>
          <Text size="sm" ml={5}>
            {item.name}
          </Text>
        </Group>
      </Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.type}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Menu>
          <Menu.Target>
            <ActionIcon variant="default" radius="xl" aria-label="Options">
              <IconDots style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item color="dark">Edit</Menu.Item>
            <Menu.Item color="dark">Hide</Menu.Item>
            <Menu.Item color="dark">Replace</Menu.Item>
            <Menu.Item color="red" onClick={() => {}}>
              Delete
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Table.Td>
    </Table.Tr>
  ))

  const handleAddClick = () =>
    navigate(
      [
        RoutePaths.ADMIN_SETTINGS,
        RoutePaths.ADMIN_SETTINGS_CALLS,
        RoutePaths.ADMIN_SETTINGS_CALLS_DISPOSITIONS,
        RoutePaths.ADMIN_SETTINGS_CALLS_DISPOSITIONS_ADD,
      ].join('/'),
    )

  return (
    <>
      <Flex justify="flex-end" p="xs">
        <Button onClick={handleAddClick}>Add Disposition</Button>
      </Flex>
      <Table withRowBorders={false} verticalSpacing="xs">
        <Table.Thead>
          <Table.Tr className={classes.AdminSettings__thead}>
            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Name
              </Text>
            </Table.Th>

            <Table.Th key={`columns-2`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Type
              </Text>
            </Table.Th>

            <Table.Th>
              <Text size="xs">7 results</Text>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>

      <Outlet />
    </>
  )
}
